<template>
  <div class="brand-page" ref="gallery">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -5px;color:rgba(52,152,219,1);"
        ></i>用户详情
      </div>
    </div>
    <div style="width: 1056px;margin: 0 auto;" class="filtrate">
      <div style="width: 1056px;margin: 0 auto;border:1px solid #ddd; display:flex;">
        <div class="head_left">
          <div class="head_left_div">
            <div style="width:72px;height:72px">
              <el-image style="border-radius:50%" :src="headImg" alt />
            </div>

            <p>{{mobile}}</p>
          </div>
        </div>
        <div class="head_center">
          <div class="table1">
            <table class="tab_box" cellspacing="0">
              <tr class="tab_tr">
                <th class="tab_th">用户账号</th>
                <td class="tab_td">{{mobile}}</td>
              </tr>

              <tr class="tab_tr">
                <th class="tab_th">昵称</th>
                <td class="tab_td">{{nickname}}</td>
              </tr>
              <tr class="tab_tr">
                <th class="tab_th">性别</th>
                <td class="tab_td">{{sex}}</td>
              </tr>
              <tr class="tab_tr">
                <th class="tab_th">生日</th>
                <td class="tab_td">{{birthday}}</td>
              </tr>
              <tr class="tab_tr">
                <th class="tab_th">邮箱</th>
                <td class="tab_td">{{email}}</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="head_right">
          <div class="table1">
            <table class="tab_box" cellspacing="0">
              <tr class="tab_tr">
                <th class="tab_th">主账户</th>
                <td class="tab_td">{{p_user}}</td>
              </tr>
              <tr class="tab_tr">
                <th class="tab_th">推荐人</th>
                <td class="tab_td">{{c_user}}</td>
              </tr>
              <tr class="tab_tr">
                <th class="tab_th">绑定电话</th>
                <td class="tab_td">{{bind_mobile}}</td>
              </tr>
              <tr class="tab_tr">
                <th class="tab_th">注册时间</th>
                <td class="tab_td">{{create_date}}</td>
              </tr>
              <tr class="tab_tr">
                <th class="tab_th">账户余额</th>
                <td class="tab_td">
                  <div style="display:flex;justify-content: space-between;">
                    <span>{{balance}}</span>
                    <span
                      style="padding-right:20px;color:#3498db;cursor: pointer;"
                      @click="open"
                    >添加余额</span>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div style="width: 1056px;margin: 0 auto;border:1px solid #ddd;margin-top:20px;">
        <div class="table1">
          <template>
            <div
              style="display:flex;align-items:center;justify-content: space-between;padding-top:20px;"
            >
              <div style="display:flex;align-items:center; ">
                <i class="fas fa-bookmark fa-lg" style="margin-left:30px;color:#999999"></i>
                <p style="margin-left:6px;color:#333">统计信息</p>
              </div>
              <div style="margin-right:20px;">
                <el-button size="small" @click="ishostSubmit()">{{text}}</el-button>
                <el-button @click="paymentClick()" size="small">{{payment}}用户权限</el-button>
              </div>
            </div>

            <el-table
              border
              :data="tableData1"
              style="width: 96%; margin:0 auto"
              header-row-class-name="row-header"
            >
              <el-table-column prop="pay_sum_money" align="center" label="消费金额"></el-table-column>
              <el-table-column prop="count_order" align="center" label="订单数量"></el-table-column>
              <el-table-column prop="integral" align="center" label="可用积分"></el-table-column>
              <el-table-column prop="coupons" align="center" label="优惠券(张)"></el-table-column>
              <el-table-column prop="return_product" align="center" label="退换货记录"></el-table-column>
              <el-table-column prop="login_num" align="center" label="登陆次数"></el-table-column>
              <el-table-column prop="collect" align="center" label="收藏商品"></el-table-column>
              <el-table-column width="120" prop="invite_friend" align="center" label="邀请好友"></el-table-column>
              <el-table-column width="120" prop="child" align="center" label="子账户个数"></el-table-column>
            </el-table>
          </template>
        </div>
        <div class="table1">
          <template>
            <div style="display:flex;align-items:center; ">
              <i class="fas fa-bookmark fa-lg" style="margin-left:30px;color:#999999"></i>
              <p style="margin-left:6px;color:#333">收货地址</p>
            </div>
            <el-table
              :data="tableData2"
              style="width: 96%;margin:0 auto"
              row-key="id"
              border
              :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
            >
              <el-table-column prop="name" align="center" label="姓名" width="180"></el-table-column>
              <el-table-column prop="mobile" align="center" label="手机号码" width="180"></el-table-column>
              <el-table-column width="500" prop="adds" align="center" label="详细地址"></el-table-column>
              <el-table-column prop="default" align="center" label="默认地址">
                <template slot-scope="scope">
                  <el-switch
                    @change="status($event,scope.row.id)"
                    v-model="scope.row.default"
                    active-color="rgb(19, 206, 102)"
                    inactive-color="#dcdfe6"
                    active-value="1"
                    inactive-value="0"
                  ></el-switch>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </div>
        <div class="table1 table_bottom">
          <template>
            <div style="display:flex;align-items:center; ">
              <i class="fas fa-bookmark fa-lg" style="margin-left:30px;color:#999999"></i>
              <p style="margin-left:6px;color:#333">订单详情</p>
            </div>
            <el-table
              border
              :data="tableData3"
              style="width: 96%; margin:0 auto"
              header-row-class-name="row-header"
            >
              <el-table-column prop="orderCode" align="center" label="订单编号" width="200"></el-table-column>
              <el-table-column prop="create_time1" align="center" label="提交时间" width="180"></el-table-column>
              <el-table-column prop="mobile" align="center" label="用户账户"></el-table-column>
              <el-table-column prop="pay_money" align="center" label="订单金额"></el-table-column>
              <el-table-column prop="pay_type" align="center" label="支付方式"></el-table-column>
              <el-table-column prop="express.express_code" align="center" label="操作">
                <template slot-scope="scope">
                  <button class="button1" @click="inser(scope.row.id,6)">查看订单</button>
                </template>
              </el-table-column>
            </el-table>
          </template>
          <div v-if="total > 6" class="pager" style="text-align:center ; margin:0;">
            <el-row>
              <el-col>
                <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="total"
                  :page-size="6"
                  @current-change="setPage"
                ></el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
   

<script>
import $ from 'jquery'
export default {
  name: 'gallery',
  data() {
    return { serve: this.$store.state.serve,
      ids: '',
      headImg: '',
      mobile: '',
      nickname: '',
      sex: '',
      birthday: '',
      email: '',
      p_user: '', //主账户
      c_user: '', //推荐人
      bind_mobile: '',
      create_date: '',
      id: this.$route.params.id,
      tableData: [],
      tableData1: [], //统计信息
      tableData2: [], //收货地址
      tableData3: [], //订单详情
      page: '',
      total: 0,
      payment: '',
      ////////////////////////
      username: '',
      token: '',
      img: '',
      balance: '',
      s: Number,
      text: ''
    }
  },
  created() {
    if (this.$route.params.s == '1') {
      this.$store.state.topActiveId = 4
      this.$store.state.leftTitle = '用户列表'
    }
    if (this.$route.params.s == '2') {
      this.$store.state.topActiveId = 4
      this.$store.state.leftTitle = '闲置交换审核'
      this.s = 5
    }
    if (this.$route.params.s == '3') {
      this.$store.state.topActiveId = 4
      this.$store.state.leftTitle = 'bioflinnews审核'
      this.s = 6
    }

    this.geting()
    this.geting1()
    this.ishost()
  },
  watch: {},

  methods: {
    ishost() {
      this.axios
        .get(this.serve+'/admin/is_open_host', {
          params: {
            username: this.username,
            token: this.token,
            mobile: this.id
          }
        })
        .then(res => {
          if (res.data == 0) {
            this.text = '开通主账户'
          } else if (res.data == 1) {
            this.text = '关闭主账户'
          }
        })
    },
    ishostSubmit() {
      this.$confirm('此操作将会开通或关闭主账户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.axios
            .get(this.serve+'/admin/open_host', {
              params: {
                username: this.username,
                token: this.token,
                mobile: this.id
              }
            })
            .then(res => {
              if (res.data.status == 'success') {
                this.geting()
                this.ishost()
                this.$message({
                  type: 'success',
                  message: '操作成功!'
                })
              } else if (res.data.status == 'error') {
                this.$message.error(res.data.msg)
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    paymentClick() {
      this.$confirm('此操作将会开通或关闭账期支付, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.axios
            .get(this.serve+'/admin/open_close_payment', {
              params: {
                username: this.username,
                token: this.token,
                mobile: this.id
              }
            })
            .then(res => {
              if (res.data.status == 'success') {
                this.geting()
                this.$message({
                  type: 'success',
                  message: '操作成功!'
                })
              } else if (res.data.status == 'error') {
                this.$message.error(res.data.msg)
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    inser(id, s) {
      let routeUrl = this.$router.resolve({
        path: '/admin/d_viewOrde/' + id + '/1'
      })
      window.open(routeUrl .href, '_blank');
    },
    setPage(v) {
      this.page = v
      this.geting1(v)
      this.selectAll = false
    },
    status(v, id) {
      //禁用激活
      const that = this
      this.username = this.$cookies.get('username')
      this.token = this.$cookies.get('token')
      this.axios
        .get(this.serve + '/admin/change_default_address', {
          params: {
            username: this.username,
            token: this.token,
            id: id,
            mobile: this.id
          }
        })
        .then(res => {
          this.geting()
          if (res.data.status == 'success') {
            if (v == 1) {
              var str = '修改默认地址'
            } else {
              var str = '禁用'
            }
            this.$notify({
              title: str + '成功',
              message: '管理员' + str + '成功',
              type: 'success'
            })
          }
        })
    },
    open() {
      this.$prompt('请输入金额', '添加余额', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(({ value }) => {
          this.axios
            .get(this.serve+'/admin/add_balance', {
              params: {
                username: this.username,
                token: this.token,
                money: value,
                mobile: this.mobile
              }
            })
            .then(res => {
              if (res.data.status == 'success') {
                this.geting()
                this.$message({
                  type: 'success',
                  message: '添加金额: ' + value
                })
              } else if (res.data.status == 'error') {
                this.$message.error('添加失败')
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          })
        })
    },
    open4() {
      this.$message.error('提交失败')
    },
    geting(id) {
      const that = this
      this.username = this.$cookies.get('username')
      this.token = this.$cookies.get('token')
      this.axios
        .get(this.serve+'/admin/home_user_info', {
          params: {
            username: this.username,
            token: this.token,
            mobile: this.id
          }
        })
        .then(res => {
          if (res.data.status == 'success') {
            if (res.data.data.other.payment_open == '1') {
              this.payment = '关闭'
            } else if (res.data.data.other.payment_open == '0') {
              this.payment = '开通'
            }
            that.tableData2 = []
            that.tableData0 = []
            that.tableData1 = []
            var json_head = res.data.data.head
            //头部
            that.headImg = json_head.headImg
            that.mobile = json_head.mobile
            that.nickname = json_head.nickname
            if (json_head.sex == '0') {
              json_head.sex = '保密'
              that.sex = json_head.sex
            }
            if (json_head.sex == '1') {
              json_head.sex = '男'
              that.sex = json_head.sex
            }
            if (json_head.sex == '2') {
              json_head.sex = '女'
              that.sex = json_head.sex
            }
            that.birthday = json_head.birthday
            that.email = json_head.email
            that.p_user = json_head.p_user
            that.c_user = json_head.c_user
            that.bind_mobile = json_head.bind_mobile
            that.balance = json_head.balance
            var time = json_head.create_date
            var timeNew = new Date(parseInt(time) * 1000)
              .toLocaleString()
              .replace(/:\d{1,2}$/, ' ')
            that.create_date = timeNew
            //统计信息
            var json1 = res.data.data.statistic
            that.tableData1.push(json1)
            //收货地址
            var json2 = res.data.data.address
            var children = [];
            for (var key in json2) {
              if (json2[key].default == 1) {
                that.tableData2.push(json2[key])
                var adds =
                  json2[key].province +
                  json2[key].city +
                  json2[key].area +
                  json2[key].address
                json2[key].adds = adds
              }else{
                children.push(json2[key])
                var adds =
                  json2[key].province +
                  json2[key].city +
                  json2[key].area +
                  json2[key].address
                json2[key].adds = adds
              }
            }
            if(children.length != 0)
            {
              that.tableData2[0].children = children;
            }
          }
        })
    },
    geting1(page) {
      const that = this
      this.username = this.$cookies.get('username')
      this.token = this.$cookies.get('token')
      this.axios
        .get(this.serve+'/admin/home_user_order', {
          params: {
            username: this.username,
            token: this.token,
            mobile: this.id,
            page: this.page
          }
        })
        .then(res => {
          that.tableData3 = []
          var json = res.data.data
          that.page = json.page
          that.total = json.total
          for (var key in json.order) {
            that.tableData3.push(json.order[key])
            var time = json.order[key].create_time
            var timeNew = new Date(parseInt(time) * 1000)
              .toLocaleString()
              .replace(/:\d{1,2}$/, ' ')
            json.order[key].create_time1 = timeNew
          }
        })
    }
  }
}
</script>

<style lang="scss">
.el-table th {
  background-color: rgba(245, 250, 249, 1);
}
.topBar {
  margin-bottom: 40px;
  .el-step__icon {
    height: 54px;
    width: 54px;
  }
  .subTitle {
    width: 1050px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
  }
  .rutun {
    width: 78px;
    height: 28px;
    background: #fff;
    border: 1px solid rgba(221, 221, 221, 1);
    text-align: center;
    margin-top: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
  }
  .rutun:hover {
    color: #0099ff;
  }
}
.table_bottom {
  padding-bottom: 30px;
}
.table1 {
  background: #fff;
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: 'MicrosoftYaHeiLight';
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .tab_box {
    width: 412px;
    margin: 0 auto;
    .tab_tr {
      border: 1px solid rgba(221, 221, 221, 1);
      .tab_th {
        padding: 0;
        margin: 0;
        width: 100px;
        height: 44px;
        background: rgba(245, 250, 249, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        font-size: 14px;
        text-align: right;
        padding-right: 40px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
      .tab_td {
        padding: 0;
        margin: 0;
        border: 1px solid rgba(221, 221, 221, 1);
        padding-left: 20px;
        font-size: 14px;
        width: 312px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
    }
  }
}

.filtrate {
  width: 1060px;
  margin-left: 420px;
  // background: orange;
  .head_left {
    width: 240px;
    height: 230px;
    background: #f5faf9;
    .head_left_div {
      width: 100%;
      height: 100%;
      color: #cccccc;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      p {
        font-style: normal;
      }
    }
  }
  .filtrate_head {
    height: 130px;
    width: 100%;
    margin-bottom: 30px;
    // background: pink;
    .filtrate_filer {
      height: 46px;
      width: 1040px;
      background: rgba(238, 238, 238, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 16px;
      font-family: 'MicrosoftYaHei';
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 46px;
      padding-left: 14px;
    }
    .el-input__inner {
      // height: 28px;
    }
    .el-input__icon {
      line-height: 28px;
    }
  }
  .form-title {
    height: 46px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .filtrate_center {
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: 'MicrosoftYaHeiLight';
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }
}
.brand-page {
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  .claify {
    width: 4px;
    height: 16px;
    background: rgba(52, 152, 219, 1);
    position: absolute;
    top: 17px;
    left: -10px;
  }
  .cover {
    width: 50px;
    display: block;
    margin: 0 auto;
  }
  .topBar {
    margin-bottom: 40px;
  }
  .subTitle {
    position: relative;
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
  }
}
</style>

